// export function sayHello(name: string) {
//     return `Hello from ${name} !`;
// }

import { areaData, phoneMax } from "./config";

// 分割 link 参数（查询键值均为字符串）
export function splitLink(
  link: string = location.search,
): Record<string, string> {
  const backData: Record<string, string> = {};

  link.replace(/([^?&=]+)=([^&]+)/g, (_, k: string, v: string) => {
    backData[k] = v;
    return "";
  });

  return backData;
}

/** 布局形态：与 {@link phoneMax}（750 设计宽）对比 */
export type ViewportLayoutMode = "pc" | "app";

/**
 * 先取设备视口宽度，与 {@link phoneMax} 比较得布局形态；scale 以 phoneMax/2 为基准比例，下限为 1。
 * 若视口宽度 **大于** phoneMax，则 scale 固定为 1。
 * 否则 scale = max(1, 视口宽度 / (phoneMax / 2))。
 */
export function getViewportLayout(): {
  mode: ViewportLayoutMode;
  scale: number;
} {
  const w =
    typeof document !== "undefined"
      ? document.documentElement.clientWidth || window.innerWidth
      : 0;
  const max = Number(phoneMax);
  const scale =
    w > max ? 1 : Math.max(1, max > 0 ? w / (max / 2) : 1);
  return {
    mode: w <= max ? "app" : "pc",
    scale,
  };
}

// 大区过滤
export function zidFilter(v: string) {
  return areaData[v] || v;
}

// 移除字串所有空格
export function trimFilter(str: string | number) {
  if (typeof str === "number") {
    str = str.toString();
  }
  return str.replace(/\s+/g, "");
}

/**
 * 分页
 * size:number  每页个数 默认10
 */
export function splitPage(arr = [], size: number = 10) {
  const len = Math.ceil(arr.length / size);
  let backArr = [];
  for (let i = 0; i < len; i++) {
    backArr.push(arr.slice(i * size, (i + 1) * size));
  }
  return backArr;
}
